import initialState from './initialState';
 import {
 	FLOW_ADMIN_DETAIL_CHANGE_FLOW_ACTION,
 	FETCH_FLOW_ADMIN_DETAIL_INIT,
 	FETCH_FLOW_ADMIN_DETAIL_SUCCESS,
 	FETCH_FLOW_ADMIN_DETAIL_FAILURE, 
	BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_INIT,
	BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_SUCCESS,
	BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_FAILURE, 
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_INIT,
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_SUCCESS,
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_FAILURE,
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_RESET,
	FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_INIT,
	FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_SUCCESS,
	FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_FAILURE,
	FLOW_ADMIN_DETAIL_SAVE_STATS_INIT,
	FLOW_ADMIN_DETAIL_SAVE_STATS_SUCCESS,
	FLOW_ADMIN_DETAIL_SAVE_STATS_FAILURE,
	FLOW_ADMIN_DETAIL_RESET
 } from '../../actions/flow_admin_detail/types';

 export default function flowAdminDetail(state = initialState, action) {
 	switch (action.type) {
 		case FLOW_ADMIN_DETAIL_RESET:
			return initialState;
 		case FLOW_ADMIN_DETAIL_CHANGE_FLOW_ACTION:
 			var dataChanges = {...state.dataChanges};
 			if(action.payload.action=="clearState") {
 				delete dataChanges[action.payload.modifiedFlow.id];
 			}
 			else {
				dataChanges[action.payload.modifiedFlow.id] = 
					action.payload;
 			}
 			return{
 				...state,
 				dataChanges: dataChanges
 			}; 	
 		case FETCH_FLOW_ADMIN_DETAIL_INIT:
 			return{
 				...state,
 				loading: true,
 				error: null,
 				datos: {},
 				dataChanges: {}
 			}; 		
 		case FETCH_FLOW_ADMIN_DETAIL_SUCCESS:
 			return{
 				...state,
 				datos: action.payload.data,
 				error: null,
 				loading: false,
 				status: action.payload.status
 			};
 		case FETCH_FLOW_ADMIN_DETAIL_FAILURE:
 			return{
 				...state,
 				datos: {},
 				dataChanges: {},
 				error: action.payload,
 				loading: false,
 			};
		case BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_INIT:
			return {
				...state,
				backgroundFetch : {
					...state.backgroundFetch,
					error: null,
					loading: true
				}				
			};
	    case BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_SUCCESS:
			return {
				...state,
				datos: action.payload.data,
				backgroundFetch : {
					...state.backgroundFetch,
					error: null,
					loading: false,
					status: action.payload.status
				}	
			};
	    case BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_FAILURE:
			return {
				...state,
				backgroundFetch : {
					...state.backgroundFetch,
					error: action.payload,
					loading: false,
					status: 500
				}
			};
		case FLOW_ADMIN_DETAIL_VALIDATE_FLOW_INIT:
			return {
				...state,
				validateFlow : {
					...state.validateFlow,
					error: null,
					loading: true
				}				
			};
	    case FLOW_ADMIN_DETAIL_VALIDATE_FLOW_SUCCESS:
			return {
				...state,
				validateFlow : {
					...state.validateFlow,
					error: null,
					loading: false,
					data: action.payload.data,
					status: action.payload.status
				}	
			};
	    case FLOW_ADMIN_DETAIL_VALIDATE_FLOW_FAILURE:
			return {
				...state,
				validateFlow : {
					...state.validateFlow,
					error: action.payload,
					loading: false,
					status: 500,
					data: {}
				}
			};
		case FLOW_ADMIN_DETAIL_VALIDATE_FLOW_RESET:
			return {
				...state,
				validateFlow : initialState.validateFlow	
			};
		case FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_INIT:
			return {
				...state,
				saveFlowActions : {
					...state.saveFlowActions,
					error: null,
					loading: true
				}				
			};
	    case FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_SUCCESS:
	    	var dataChanges = state.dataChanges;
	    	if(action.payload.status==200) {
				dataChanges = {};
	    	}
			return {
				...state,
				dataChanges: dataChanges,
				saveFlowActions : {
					...state.saveFlowActions,
					error: null,
					loading: false,
					data: action.payload.data,
					status: action.payload.status
				}	
			};
	    case FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_FAILURE:
			return {
				...state,
				saveFlowActions : {
					...state.saveFlowActions,
					error: action.payload,
					loading: false,
					status: 500,
					data: {}
				}
			};
		case FLOW_ADMIN_DETAIL_SAVE_STATS_INIT:
			return {
				...state,
				saveStats : {
					...state.saveStats,
					error: null,
					loading: true
				}				
			};
	    case FLOW_ADMIN_DETAIL_SAVE_STATS_SUCCESS:
			return {
				...state,
				saveStats : {
					...state.saveStats,
					error: null,
					loading: false,
					data: action.payload.data,
					status: action.payload.status
				}	
			};
	    case FLOW_ADMIN_DETAIL_SAVE_STATS_FAILURE:
			return {
				...state,
				saveStats : {
					...state.saveStats,
					error: action.payload,
					loading: false,
					status: 500,
					data: {}
				}
			};
 		default:
 			return state;
	 	}
 }


// WEBPACK FOOTER //
// ./source/client/reducers/flow_admin_detail/index.js